<template>
  <div>
    <CoreBottomSheet
      v-if="isMobile"
      :value="isActive"
      :title="title"
      @input="handleInput"
    >
      <div class="text-body-1 text--text">
        {{ description }}
      </div>
      <template #actions>
        <div class="w-100">
          <v-btn
            block
            elevation="0"
            color="bg-primary"
            class="primary--text branding-btn branding-btn--background"
            data-qa="award-winner-dialog-more"
            @click="emit('redirect')"
          >
            {{ buttonText }}
          </v-btn>
        </div>
      </template>
    </CoreBottomSheet>
    <CoreDialog
      v-else
      divider
      size="md"
      :value="isActive"
      :title="title"
      @input="handleInput"
    >
      <div class="text-body-1 text--text">
        {{ description }}
      </div>
      <template #actions>
        <v-btn
          text
          data-qa="award-winner-dialog-close"
          @click="emit('input', false)"
        >
          {{ i18next.t('Закрыть', { ns: i18next.language }) }}
        </v-btn>
        <v-btn
          text
          class="branding-btn branding-btn--primary"
          color="primary"
          data-qa="award-winner-dialog-more"
          @click="emit('redirect')"
        >
          {{ buttonText }}
        </v-btn>
      </template>
    </CoreDialog>
  </div>
</template>

<script setup lang="ts">
import i18next from 'i18next'
import useIsMobile from 'src/composables/useIsMobile'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'

type Emits = {
  (_event: 'input', _value: boolean): void
  (_event: 'redirect'): void
}

const props = defineProps<{
  type: 'doctor' | 'lpu'
  title: string
  isActive: boolean
  currentAwardYear: number
}>()
const emit = defineEmits<Emits>()

const isMobile = useIsMobile()

const descriptionData = {
  lpu: i18next.t('Клиника признана по отзывам одной из лучших в регионе.', { ns: i18next.language }),
  doctor: i18next.t('Врач признан по отзывам одним из лучших в регионе в своей специальности.', { ns: i18next.language }),
}
const buttonDescription = {
  lpu: i18next.t('Все награды клиники', { ns: i18next.language }),
  doctor: i18next.t('Все награды врача', { ns: i18next.language }),
}
const description = descriptionData[props.type]
const buttonText = buttonDescription[props.type]

function handleInput(val: boolean) {
  emit('input', val)
}
</script>
